import HttpClient from "../HttpClient";
import ConstructSequelizeFilters from "../utils/ConstructSequelizeFilters";

export class WalletTransactionService {
    async getAllWalletTransactions(
        limit: number,
        offset: number,
        filters: any,
        sort: any,
      ) {
        let nullFilters: string[] = [];
        let notNullFilters: string[] = [];
        let filter = ConstructSequelizeFilters(filters, [], ['userWalletId','referenceId','referenceModelName'], nullFilters, notNullFilters);
        filters = {
          ...filter,
        }
        let data = await HttpClient.get("/wallet/centaurus/transactions", {
          params: {
            limit,
            offset,
            filters,
            sort,
          },
        });
        return {
          data: data?.data?.data,
          total: data?.data?.count,
        };
      }

      async getAllWalletTransactionsForUser(
        walletId: number,
        limit: number,
        offset: number,
        sort: any,
      ) {
        let filter = {"userWalletId": walletId};
        let filters = ConstructSequelizeFilters(filter, [], ['userWalletId']);
        let data = await HttpClient.get("/wallet/centaurus/transactions", {
          params: {
            limit,
            offset,
            filters,
            sort,
          },
        });
        return data?.data;
      }

      async getWalletTransactionById(id: number) {
        let data = await HttpClient.get(`/wallet/centaurus/transactions/${id}`);
        return data;
    }

    async createWalletNegativeEntry(userId: number, amount: string, referenceId: number, referenceModelName: string, notes?: string){
        let payload: any = {
            userId: Number(userId),
            amount,
            referenceId: Number(referenceId),
            referenceModelName,
        }
        if (notes) {
            payload.notes = notes;
        }

        let data = await HttpClient.post(`/wallet/centaurus/wallet-entry`, payload);
        return data
    }
}